import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';

import ReactTable from '../../../../components/ReactTable';
import { selectAdminPageCodes } from '../../../../redux/modules/adminPage';
import boxStyles from '../../../../styles/boxStyles';
import { createHeaderCell } from '../../../../utils/tableUtil';

function CodesTable() {
  const companyCodes = useSelector(selectAdminPageCodes);

  const columns = [
    {
      Header: createHeaderCell('Code Letter'),
      id: 'code',
      accessor: 'letter',
      order: 1,
      defaultCanSort: true
    },
    {
      Header: createHeaderCell('Code Description'),
      id: 'description',
      accessor: 'description',
      order: 2,
      disableSortBy: true
    },
    {
      Header: createHeaderCell('Point Value Applied Month'),
      id: 'pointValue',
      accessor: 'value',
      order: 3,
      defaultCanSort: true
    },
    {
      Header: createHeaderCell('Point Value Aged Month 1'),
      id: 'pointValueAgedMonth1',
      accessor: 'pointValueAgedMonth1',
      order: 4,
      defaultCanSort: true
    },
    {
      Header: createHeaderCell('Point Value Aged Month 2'),
      id: 'pointValueAgedMonth2',
      accessor: 'pointValueAgedMonth2',
      order: 5,
      defaultCanSort: true
    },
    {
      Header: createHeaderCell('Point Value Aged Month 3'),
      id: 'pointValueAgedMonth3',
      accessor: 'pointValueAgedMonth3',
      order: 6,
      defaultCanSort: true
    },
    {
      Header: createHeaderCell('Point Value Aged Month 4'),
      id: 'pointValueAgedMonth4',
      accessor: 'pointValueAgedMonth4',
      order: 7,
      defaultCanSort: true
    },
    {
      Header: createHeaderCell('Point Value Aged Month 5'),
      id: 'pointValueAgedMonth5',
      accessor: 'pointValueAgedMonth5',
      order: 8,
      defaultCanSort: true
    }
  ];

  const data = companyCodes?.map(code => ({
    ...code,
    pointValueAgedMonth1: code.value * (parseInt(code.multiplier, 10) ** 1),
    pointValueAgedMonth2: code.value * (parseInt(code.multiplier, 10) ** 2),
    pointValueAgedMonth3: code.value * (parseInt(code.multiplier, 10) ** 3),
    pointValueAgedMonth4: code.value * (parseInt(code.multiplier, 10) ** 4),
    pointValueAgedMonth5: code.value * (parseInt(code.multiplier, 10) ** 5)
  }));

  return (
    <Box bgColor="white" borderRadius="md">
      <ReactTable
        backgroundColor="inherit"
        color="greyScale.900"
        tableColumns={columns}
        tableData={data}
      />
    </Box>
  );
}

export default CodesTable;
